<script lang="ts">
	import { removeFromCartSchema } from '$lib/validations/cart/remove-from-cart-schema';
	import { superForm, type Infer, type SuperValidated } from 'sveltekit-superforms';
	import type { ButtonVariant } from '$lib/components/ui/button';
	import LoaderCircle from '@lucide/svelte/icons/loader-circle';
	import { zodClient } from 'sveltekit-superforms/adapters';
	import { generateIdFromEntropySize } from 'lucia';
	import * as Form from '$lib/components/ui/form';
	import Trash from '@lucide/svelte/icons/trash';

	interface Props {
		removeFromCartForm: SuperValidated<Infer<typeof removeFromCartSchema>>;
		variant: ButtonVariant;
		cartItemId: number;
	}

	let { removeFromCartForm, cartItemId, variant = 'secondary' }: Props = $props();

	const form = superForm(removeFromCartForm, {
		validators: zodClient(removeFromCartSchema),
		id: generateIdFromEntropySize(4),
		applyAction: false
	});

	const { enhance, form: formData, delayed } = form;
</script>

<form method="POST" action="/warenkorb?/removeFromCart" use:enhance class="w-full">
	<Form.Field {form} name="cartItemId">
		<Form.Control>
			{#snippet children({ props })}
				<Form.Label class="sr-only">Warenkorb Item ID</Form.Label>
				<input {...props} bind:value={() => cartItemId, (v) => ($formData.cartItemId = v)} hidden />
			{/snippet}
		</Form.Control>
	</Form.Field>
	<Form.Button {variant} class="hidden w-full md:flex">
		{#if $delayed}
			<LoaderCircle class="size-5 animate-spin" />
		{:else}
			<Trash class="size-5" /> Entfernen
		{/if}
	</Form.Button>
	<Form.Button {variant} class="md:hidden" size="icon">
		<Trash class="size-5" /><span class="sr-only">Aus dem Warenkorb entfernen</span>
	</Form.Button>
</form>
